// extracted by mini-css-extract-plugin
export default {"background":"Products_background__rnYkM","topImage":"Products_topImage__zfVfE","bottomImage":"Products_bottomImage__M4quU","threeStepsImage":"Products_threeStepsImage__atRav"};